module.exports = __webpack_public_path__ + "static/img/6bg_5.7e10729.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/6bg_5.png
// module id = 731
// module chunks = 1